document.addEventListener('DOMContentLoaded', function () {
  var $custom = window.jQuery ? window.jQuery.noConflict(true) : null;

  function openPopup() {
    var isDesktopFullscreen = window.innerWidth >= 769 &&
      document.querySelector('#popup').dataset.desktopType === 'fullscreen';

    if (isDesktopFullscreen) {
      if (!$custom || !$custom.fn.fancybox) {
        console.error('jQuery/fancybox non caricati correttamente.');
        return;
      }
      document.querySelector('#popup').classList.add('fullscreen');
      document.querySelector('#fullscreen').removeAttribute('style');
      $custom.fancybox({
        autoScale: true,
        transitionIn: 'elastic',
        transitionOut: 'elastic',
        speedIn: 500,
        speedOut: 300,
        autoDimensions: true,
        centerOnScroll: true,
        href: '#popup #fullscreen',
        wrapCSS: 'fullscreen-popup-fancybox',
        tpl: {
          closeBtn: '<div class="popup--close fancybox-close" tabindex="0"></div>'
        }
      });
    } else {
      var popupEl = document.getElementById('popup');
      var slideUpEl = document.getElementById('slide-up');
      if (!popupEl || !slideUpEl) return;
      slideUpEl.removeAttribute('style');
      popupEl.classList.add('slide-up');
      popupEl.classList.add('visible');
    }
  }

  // Apertura via click sul bottone rosso
  var btn = document.getElementById('PopupTriggerBtn');
  if (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openPopup();
    });
  }

  // Riapertura automatica dopo iscrizione avvenuta con successo
  if (document.querySelector('[data-popup-newsletter-success]')) {
    openPopup();
  }
});